/**
 * Helpers for turning an API error body into something a user can actually read.
 *
 * Requests made with `responseType: 'blob'` (file exports) get a Blob error body too, not JSON,
 * so the raw body renders as "[object Object]" in a toast. CORE-7571.
 */

/**
 * Decode a Blob error body back to the JSON/text the server sent. Non-Blob bodies pass through
 * untouched. Returns null when the body is empty or unreadable, so callers fall back to their
 * own message.
 */
export async function decodeErrorData(data) {
    if (typeof Blob === 'undefined' || !(data instanceof Blob))
        return data;

    try {
        const text = await data.text();
        if (!text)
            return null;

        try {
            return JSON.parse(text);
        } catch (notJson) {
            return text;
        }
    } catch (unreadable) {
        return null;
    }
}

/**
 * Pull a displayable string out of an error body. Returns null when there is nothing readable,
 * so the caller's own message is shown instead of "[object Object]".
 */
export function toDisplayableError(data) {
    if (typeof data === 'string')
        return data.trim() || null;

    if (data && typeof data === 'object')
        return data.message || data.title || data.detail || data.error || null;

    return null;
}
